import styled from '@emotion/styled';

export const MainBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`;
